import * as React from 'react';
import Dialog from '@material-ui/core/Dialog/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import { reaction } from 'mobx';
import { observer } from 'mobx-react-lite';
import Button from '@material-ui/core/Button';
import { PositionWatcherError } from './gps/PositionWatcher';
const GpsErrorDialog = observer((props) => {
    // model = observable.box(false);
    const [open, setOpen] = React.useState(false);
    React.useEffect(() => {
        return reaction(() => {
            return props.positionWatcher.error !== undefined;
        }, (open) => {
            if (open)
                setOpen(true);
        });
    });
    const _onClose = () => {
        setOpen(false);
    };
    const err = props.positionWatcher.error;
    if (err === undefined)
        return null;
    let errStr = undefined;
    if (err.code === PositionWatcherError.PERMISSION_DENIED) {
        errStr = 'Permission denied';
    }
    else if (err.code === PositionWatcherError.TIMEOUT || err.code === PositionWatcherError.POSITION_UNAVAILABLE) {
        errStr = 'Gps Unavailable';
    }
    else if (err.code === PositionWatcherError.OTHER) {
        errStr = err.message ? err.message : 'Unknown Error';
    }
    return (React.createElement(Dialog, { open: open, onClose: _onClose },
        React.createElement(DialogTitle, null, "Gps Error"),
        React.createElement(DialogContent, null,
            React.createElement(DialogContentText, null, errStr)),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: _onClose }, "Ok"))));
});
export default GpsErrorDialog;
